import React from 'react';
import { Pencil } from 'lucide-react';

/** "Anel is editing Contact 1 · Date" — shown on a card while somebody else is typing. */
export const LiveEditors = ({ editors, tin }) => {
  if (!editors || editors.length === 0) return null;
  const first = editors[0];
  const extra = editors.length - 1;

  return (
    <div
      className="mb-2 flex items-start gap-1.5 rounded-md bg-amber-50 dark:bg-amber-950/40 border border-amber-300 dark:border-amber-800 px-2 py-1"
      data-testid={`live-editing-${tin}`}
    >
      <Pencil className="h-3 w-3 mt-0.5 shrink-0 text-amber-600 dark:text-amber-400 animate-pulse" />
      <p className="text-[10px] leading-tight text-amber-800 dark:text-amber-200">
        <span className="font-semibold">{first.name.split(' ')[0]}</span> is editing{' '}
        {first.field_label}
        {extra > 0 && ` · +${extra} more`}
      </p>
    </div>
  );
};

export default LiveEditors;
